import App from "./app.jsx";

export default App;